import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './TruckFilling.module.scss';
import { ProgressBar } from 'devextreme-react/progress-bar';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import TruckFillingSchema from './TruckFIllingSchema';
import { OrdersGridItemData } from '../../screens/orders-screen/OrdersScreen';
import { ArrowRight } from '../../assets/svg/menu/ArrowRight';
import { ArrowLeft } from '../../assets/svg/menu/ArrowLeft';
import { StyledFillingWrapper } from './styled';

const TruckFilling = (props: TruckFillingProps) => {
    const { t } = useTranslation('TruckFilling');

    const maxCapacityReachedForward =
        props.data?.forwardSteps?.filledTrailerCapacity !== undefined &&
        props.data?.forwardSteps.maxTrailerCapacity !== undefined &&
        props.data?.forwardSteps?.filledTrailerCapacity >
            props.data?.forwardSteps.maxTrailerCapacity;

    const maxCapacityReachedReturn =
        props.data?.returnSteps?.filledTrailerCapacity !== undefined &&
        props.data?.returnSteps.maxTrailerCapacity !== undefined &&
        props.data?.returnSteps?.filledTrailerCapacity > props.data?.returnSteps.maxTrailerCapacity;

    return (
        <div className={classNames(styles.box, props?.className)}>
            {props.data?.forwardSteps?.filledTrailerCapacity !== undefined &&
            props.data?.forwardSteps.maxTrailerCapacity ? (
                <div className={classNames(styles.topFilling)}>
                    <div className={classNames(styles.topFillingLeft)}>
                        <ArrowRight />
                    </div>
                    <StyledFillingWrapper
                        maxCapacityReached={maxCapacityReachedForward}
                        className={classNames(styles.topFillingRight)}
                    >
                        <ProgressBar
                            min={0}
                            max={props.data.forwardSteps.maxTrailerCapacity}
                            value={props.data.forwardSteps.filledTrailerCapacity}
                            showStatus={false}
                        />
                    </StyledFillingWrapper>
                </div>
            ) : (
                <label>{t('noData')}</label>
            )}

            <div>
                {props.data?.returnSteps?.filledTrailerCapacity !== undefined &&
                props.data?.returnSteps.maxTrailerCapacity ? (
                    <div className={classNames(styles.bottomFilling)}>
                        <div className={classNames(styles.topFillingLeft)}>
                            <ArrowLeft />
                        </div>
                        <StyledFillingWrapper
                            maxCapacityReached={maxCapacityReachedReturn}
                            className={classNames(styles.topFillingRight)}
                        >
                            <ProgressBar
                                min={0}
                                max={props.data.returnSteps.maxTrailerCapacity}
                                value={props.data.returnSteps.filledTrailerCapacity}
                                showStatus={false}
                            />
                        </StyledFillingWrapper>
                    </div>
                ) : (
                    <label>{t('noData')}</label>
                )}
            </div>
        </div>
    );
};

export type TruckFillingProps = { data?: TruckFillingData } & TruckFillingDisplayOptions;

export default withInspector<TruckFillingProps>(TruckFilling, TruckFillingSchema);

export class TruckFillingDisplayOptions {
    className?: string;
}

export type TruckFillingData = OrdersGridItemData;

export const TruckFillingDataKeys = [];
